<script setup lang="ts">
import {Plus, Settings} from "@lucide/vue";
import {Button} from "@/core/components/ui/button";
import {inject, ref} from "vue";
import useConsumerProducts from "@/consumer/composables/useConsumerProducts";
import ConsumerProductsChips from "@/drug-interaction/components/header/ConsumerProductsChips.vue";
import ConsumerProductDosageDialog from "@/drug-interaction/components/dosage/ConsumerProductDosageDialog.vue";

const props = defineProps<{
    consumerKey: string

}>();

const emits = defineEmits<{
    (e: 'trackProducts'): void;
}>();

const {data, products, isLoading} = useConsumerProducts(props.consumerKey);
const dosageOpen = ref(false);

/**
 * Shortcuts callback provided by InterviewInstanceLayoutView.vue
 */
const shortcuts = inject<{ openDrugsInteraction: () => void }>('interviewShortcuts');
</script>

<template>
  <div class="border-[1px] border-r-0 border-black rounded-md rounded-r-none min-w-[400px] p-3">
    <div class="flex gap-4">
      <div class="space-y-2">
        <span class="font-medium">
          Traitements enregistrés <button v-if="shortcuts" @click="shortcuts?.openDrugsInteraction()">
            <Settings class="text-primary w-4 h-4" />
          </button>
        </span>
        <ConsumerProductsChips
          :is-loading="isLoading"
          :products="products"
          @open-dosage-dialog="dosageOpen = true"
          @track-products="emits('trackProducts')"
        />
      </div>
      <div v-if="!isLoading && !data?.length">
        <Button variant="ghost" class="text-primary" @click="shortcuts?.openDrugsInteraction()">
          <Plus class="text-black" />
          <span class="leading-none">Ajouter un traitement</span>
        </Button>
      </div>
    </div>
    <ConsumerProductDosageDialog
      v-if="products?.length"
      v-model:open="dosageOpen"
      :products="products"
      :consumer-key="consumerKey"
    />
  </div>
</template>

<style scoped>

</style>
